
































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { dateFormat } from "@/utils/timeFormat";
import {
  delStudentCommentApi,
  commentLessonDetailApi,
} from "@/api/classroomComment";
import { courseListApi } from "@/api/course";

@Component({
  name: "commentDetail",
})
export default class extends Vue {
  searchInfo: any = {};
  tableData: any[] = []; // 练习明细列表
  page = 1;
  pageSize = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total = 5;
  commentDetail: any = {};
  courseName: any = "";
  canComment: boolean = true;

  created() {
    this.getCommentLessonDetail();
  }

  getList(params: any) {}
  getCourseList(v: any) {
    courseListApi({
      page: 1,
      page_size: 10,
      course_ids: [v],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.courseName = res.data.list[0].title;
      }
    });
  }
  getCommentLessonDetail() {
    commentLessonDetailApi({
      lesson_comment_id: Number(this.$route.query.lesson_comment_id),
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.getCourseList(res.data.course_id);
        if (res.data.class) {
          res.data.class.class_type =
            res.data.class.class_type === 1 ? "1vN" : "1v1";
        }
        res.data.lesson_full_start_time = dateFormat(
          "YYYY-mm-dd",
          new Date(res.data.lesson_full_start_time * 1000)
        );
        this.commentDetail = res.data;

        res.data.lesson_detail_studen_List.forEach((item: any) => {
          item.comment_time =
            item.comment_time === 0
              ? item.comment_time
              : dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(item.comment_time * 1000)
                );
        });
        this.tableData = res.data.lesson_detail_studen_List;
        // console.log("课次点评详细", this.commentDetail);
      }
    });
  }

  handleChange() {
    this.getList({
      page: this.page,
      pageSize: this.pageSize,
    });
  }
  toComment(...rest: any) {
    let status: any = "";
    if (rest[1] === "comment") {
      status = "comment";
      if (this.commentDetail.can_comment === 2) {
        this.$message({
          type: "error",
          message: "授课老师才能点评",
        });
        this.canComment = false;
      }
    }
    if (rest[1] === "catComment") {
      status = "catComment";
    }
    if (!this.canComment) return false;

    this.$router.push({
      name: "comment",
      query: {
        comment_student_id: rest[0].row.comment_student_id,
        comment_id: this.commentDetail.id,
        student_id: rest[0].row.student.student_id,
        name: rest[0].row.student.name,
        status: status,
      },
    });
  }
  // 复制链接
  async handleCopyLink(scope: any) {
    await navigator.clipboard.writeText(scope.row.h5_link);
    this.$message({
      message: "复制成功",
      type: "success",
    });
  }
  delComment(scope: any) {
    this.$confirm("确定撤销该点评？", `撤销${scope.row.student.name}点评`, {
      confirmButtonText: "确定",
      confirmButtonClass: "mwow-button-filled success mini",
      cancelButtonText: "取消",
      cancelButtonClass: "mwow-button-filled mini",
      iconClass: "mwow-icon-error",
    })
      .then(() => {
        delStudentCommentApi({
          lesson_comment_student_id: scope.row.comment_student_id,
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getCommentLessonDetail();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      })
      .catch(() => {});
  }

  handlePagerChange(e: number) {
    this.getList({
      page: e,
      pageSize: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      pageSize: e,
    });
  }

  goBack() {
    this.$router.push({
      name: "classroomComment",
      query: {
        from: this.$route.query.from ? this.$route.query.from : "",
      },
    });
  }
}
